import React from 'react';
import '../../styles/Arrow.scss';

const Arrow = ({ direction = 'down', size = 'medium', animated = true, onClick }) => {
    const directionAngle = {
        up: '135deg',
        right: '-135deg',
        down: '-45deg',
        left: '45deg',
      };
    
    const arrowStyle = {
        '--rotate-angle': directionAngle[direction] || '135deg',
    };

    const arrowClass = `arrow arrow--${direction} arrow--${size} ${animated ? 'arrow--animated' : ''}`;

    return <div data-aos="fade-in" className={arrowClass} style={arrowStyle} onClick={onClick} />;
};

export default Arrow;
